//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    selected: {
      default: false
    },
    tab: {
      default: null
    },
    index: {
      default: null
    }
  }
}
